import { useQuery } from "@tanstack/react-query";
import { axiosCoreInstance } from "src/config/axios";
import { CompanyDetailsModel } from "src/modules/company/types/Company";
import { Storage } from "src/utils/storage";

export const RQ_COMPANY_DETAILS_KEY = "COMPANY_DETAILS";

export const useCompanyDetails = () => {
    const currentCompany = Storage.getItem("currentCompany");

    return useQuery({
        queryKey: [RQ_COMPANY_DETAILS_KEY, currentCompany?.id],
        queryFn: async (): Promise<CompanyDetailsModel | null> => {
            if (!currentCompany?.id) return null;
            const res = await axiosCoreInstance.get(`api/company/${currentCompany.id}`);
            return res?.data || null;
        },
        enabled: !!currentCompany?.id,
    });
};
